import {
  getMedicalDeviceInfoUrlUsecase,
  getPrivacyPolicyUrlUsecase,
  getTermsOfServiceUrlUsecase,
} from "@/init/initializeInstances";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import BusinessInfo from "../business-info/business-info";
import LanguageSelector from "../language-selector/language-selector";
import { useFooterViewModel } from "./footer-view-model";
import styles from "./footer-view.module.css";

interface FooterProps {
  /**
   * 스토어(이용권 구매) 화면용 — 디자인은 메인 푸터와 동일. 스토어 경로는 EXCLUDE_FOOTER_PATH 에 있어
   * 메인 레이아웃 푸터는 숨겨지므로, 스토어 레이아웃이 이 변형을 직접 렌더링한다 (팝업 창 폭에 맞게 최소 너비만 해제).
   * 환불 정책은 주문서 동의 문구·이용권 선택 모달에서 열 수 있어 푸터에는 두지 않는다.
   */
  store?: boolean;
}

export default function Footer({ store = false }: FooterProps) {
  const vm = useFooterViewModel({
    getMedicalDeviceInfoUrlUsecase,
    getPrivacyPolicyUrlUsecase,
    getTermsOfServiceUrlUsecase,
  });

  const { t } = useTranslation();

  //MARK:- Early return for excluded paths (스토어 변형은 스토어 레이아웃이 직접 그리므로 제외 규칙을 타지 않는다)
  if (!store && vm.isExcluded) {
    return null;
  }
  const variantClass = store ? styles.storeVariant : "";

  return (
    <>
      <footer className={`${styles.footer} ${variantClass}`}>
        <div className={styles.footerContainer}>
          <LanguageSelector />
          <div style={{ flex: 1 }} />
          <div className={styles.fotterLinkContainter}>
            <Link to={vm.medicalDeviceInfoPath} className={styles.fotterText}>
              {t("footer.medical.device.info")}
            </Link>
            <Link
              to={vm.termsOfServiceUrl}
              target="_blank"
              className={styles.fotterText}
              rel="noopener noreferrer"
            >
              {t("footer.terms")}
            </Link>
            <Link
              to={vm.privacyPolicyUrl}
              target="_blank"
              className={styles.fotterText}
              rel="noopener noreferrer"
            >
              {t("footer.privacy")}
            </Link>
          </div>
        </div>
      </footer>
      <div className={`${styles.businessInfoStrip} business-info-strip ${variantClass}`}>
        <BusinessInfo tone="muted" />
      </div>
    </>
  );
}
